// This is the index component for update profile.

// ----------- Imports ------------------
//Hooks import.
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

//CSS imports.
import "../../../assets/css/register/register.css";
import logo from "../../../assets/images/register/logo.svg";
import { AiOutlineClose } from "react-icons/ai";

// Libraries imports.
import axios from "axios";
import Cookies from "universal-cookie";

// Constant and Utils imports.
import { domains } from "../../../constants/registration";
import {createCurrentUrl, certificationPage, getAbsoluteDestinationUrl, setCookiesAndRedirectionOnLogin, deviceType} from "../../../utils/registrationUtils";
import {gaEvent, gaLocationAndContentData} from "../../../utils/index";

// Components and Actions imports.
import CareersRegisterUpdateProfile from "./CareersRegisterUpdateProfile";
import CommonModal from "../../utils/commonModal";
import {
   postUserProfileClevertap,
   postUpdateProfile, 
} from "../../../../store/slices/Registration/CommonSlices";
import {fetchUser, getUserInfo } from "../../../../store/slices/user/index"
import Loading from "../../utils/loader";
import CareersRegisterLeft from "../CareersRegisterLeft"
import DataLayerEvents from "../../common/DataLayerEvents";

const RegisterUpdateProfile = (props) => {
// ----------------Local States----------------
    const [domain, setDomain] = useState(null);
    const [open, setOpen] = useState(false);
    const [reloadFlagDestination, setReloadFlagDestination] = useState(true)
    const [reloadFlagOnExit, setReloadFlagOnExit] = useState(true);
// ----------------Local Variables--------------
    const clickLocation = new URLSearchParams(window.location.search)?.get("click_location") || ''
    const cookies = new Cookies();
    //cookies data 
    const loginDataCookies = cookies?.get("loginState");
    const updateProfileCookies = cookies?.get("loginState")?.formValuesUpdateProfile
    //to check correct current url
    const subDomainName = window.location.host?.split(".")[0];
    const urlCheck = window.location.href;
    let certificationFormCheck = window.location.search?.includes("ftype=certificationform") ||
    window.location.search?.includes("ftype=certification") || certificationPage(urlCheck);
    const currentUrl = document.referrer ? document.referrer : cookies?.get(`${subDomainName}-${certificationFormCheck}-rgData`)?.source_destination;
    const urlObj = currentUrl ? new URL(currentUrl) : null;
    const cleanUrl = urlObj ? `${urlObj.origin}${urlObj.pathname}` : null;
    const sourseDestination = cleanUrl ? `${cleanUrl}${window.location.search}` : getAbsoluteDestinationUrl();
    //---------------------------------------      
    const destinationDomain = axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME;
    let updateProfileCase = cookies.get(`${subDomainName}-${certificationFormCheck}-updateProfile`); // to check what case of update profile are we dealing with
    let date = new Date();
    const checkOneLoginCookie = cookies.get("one-click-login")?.data?.uid;
// -------------- UseEffects --------------
   
  useEffect(() => {
      // Push the current URL to the history stack to prevent back navigation
      window.history.pushState(null, "", window.location.href);

      // Define the event handler for the popstate event
      const handlePopstate = (event) => {
      if(props.user || checkOneLoginCookie){
        // If the user is authenticated, navigate to the current URL or create a new URL
        window.location.href = currentUrl ? currentUrl : getAbsoluteDestinationUrl();
      }else {
      // If the user is not authenticated, navigate to the login page
      window.location.href = `/user/login${window.location.search}`;
      cookies.remove("loginState", {
        path: "/",
        domain: destinationDomain,
      });
      }
      };
      // Assign the event handler to the window's popstate event
      window.onpopstate = handlePopstate;

      // Clean up the event handler when the component is unmounted
      return () => {
        window.onpopstate = handlePopstate;
      };
    }, []);

    // setting subdomain for opening registration form for respective of subdomain.
    useEffect(() => {
      props.dispatch(fetchUser());
      let domainVal
      // Check if the current hostname includes "localhost"
      if (window.location?.hostname?.includes("localhost")) {
        // If on localhost, extract the "domain" parameter from the URL query params
        const urlParams = new URLSearchParams(window.location.search);
        domainVal = urlParams?.get("domain");
      } 
    // Check if either certificationFormCheck is true or certificationPage(urlCheck) returns true, if true set somain value to certification.
      else if(certificationFormCheck || certificationPage(urlCheck)){
        domainVal = "certification";
      }
      // Otherwise, extract the subdomain from the hostname
      else {
        domainVal = window.location.host?.split(".")[0];
      }
        let domainObj = {};
        // Find the domain object in the domains array that matches domainVal
        domainObj = domains.find((obj) => obj.name == domainVal);
        // If no matching domain object is found, default to the domain object with name "www"
        if (!domainObj) {
            domainObj = domains.find((obj) => obj.name == "www");
        }
        setDomain(domainObj);
    },[]);

    useEffect(() => {
      // redirecting to current url in case of page expiry time, this state is added to stop browser default popup on url redirection.
        if (!reloadFlagOnExit) { 
          window.location.href = currentUrl ? currentUrl : getAbsoluteDestinationUrl();
        }
    }, [reloadFlagOnExit])

        useEffect(() => {
        if (!reloadFlagDestination) { //redirection to destination on succesfull updation of data.
          window.location.href = props.updateProfileData?.destination
        }
      }, [reloadFlagDestination])

    // login access cookies added for successful login of user.
    useEffect(() => {
       // Check if login has proceeded and updating profile is completed with data updation.
      if (props.updateProfileData?.proceed == true
        && props.updateProfileData?.ask_update_profile == false) {
        // Post CleverTap events
        clevertapEvents();
        // post CleverTap user profile data
        postUserProfileClevertapData();
        // this condition is added, to ensure that login session cookies are only being saved in case of loggout case Update profile.
        if(props.userError){
        // GA event for succesful session start.
        gaEvent("sessionsignin", "login_signup", `${gaLocationAndContentData}`, "");
        // -------------- set User session cookies -----------------
        setCookiesAndRedirectionOnLogin(props.updateProfileData);
        cookies.remove("admission_form_display", { // deleted for Idp purpose.
          path: "/",
          domain: destinationDomain,
        });
        cookies.remove("admission_form_display", { // deleted for Idp purpose.
          path: "/",
          domain: window.location.host,
        });
        cookies.remove(`${subDomainName}-${certificationFormCheck}-updateProfile`, {
          path: "/",
          domain: destinationDomain,
        });
      }
       // rediercting to destination URL after succesfull updation of user update profile.
       if (props.updateProfileData?.destination) {
        setReloadFlagDestination(false)
      }
    }
    }, [props.updateProfileData, props.userError])

    // Handle user error case
      useEffect(() => {
        if(props.userError){
          gaEvent("signinupdateprofile", "login_signup", `${gaLocationAndContentData}`, "");
          cookies.set(`${subDomainName}-${certificationFormCheck}-updateProfile`, 0, {
            path: "/",
            expires: new Date(date.setDate(date.getDate() + 3)),
            sameSite: "Lax",
            domain: window.location?.hostname?.includes("localhost") ? window.location?.hostname : destinationDomain,
          });
        }
        // uncomment while deploying
        if (props.userError && !cookies.get("loginState")?.user_id) {
          let destinationUrl = getAbsoluteDestinationUrl() || createCurrentUrl();
          window.location.href = `/user/login?${destinationUrl ? "destination=" + destinationUrl : ""}`
        }
      }, [props.userError])

      useEffect(() => {
        // Handle user data loading and update cookies accordingly
        if (props.user) {
        gaEvent("onloadupdateprofile", "login_signup", `${gaLocationAndContentData}`, "");
          cookies.set(`${subDomainName}-${certificationFormCheck}-updateProfile`, 1, {
            path: "/",
            expires: new Date(date.setDate(date.getDate() + 3)),
            sameSite: "Lax",
            domain: window.location?.hostname?.includes("localhost") ? window.location?.hostname : destinationDomain,
          });
        }
      }, [props.user]);

// --------------Local Functions ---------------
   // add clevertap user profile data.
    const postUserProfileClevertapData = () => {
      const destinationUrl = getAbsoluteDestinationUrl() || createCurrentUrl();
      const loginData = cookies.get("loginState")
      let params = {};
      params.current_url = window.location.href;
      params.page_url = sourseDestination;
      params.destination = destinationUrl
      params.cta_clicked = !!cookies.get("loginState")?.google_status ? "google" : "login";
      params.certification = domain?.id == 2 ? true : false;
      params.user_id = props.loginDatas?.user_id ?? (loginData?.user_id || props.user?.id);
      if(loginData?.formValues?.email){
      params.email = loginData?.formValues?.email;
      }
      props.dispatch(postUserProfileClevertap(params));
    }

    // add clevertap events.
    const clevertapEvents = () => {
      if(updateProfileCase == 0){ // this check is added for that this event should only trigger in logout case
      let clevertapLoginEvents = {}; 
      if(loginDataCookies?.formValues?.email) clevertapLoginEvents.userEmail = loginDataCookies?.formValues?.email;
      if(loginDataCookies?.formValues?.mobile) clevertapLoginEvents.userMobile = loginDataCookies?.formValues?.mobile;
      window.dataLayer.push({...clevertapLoginEvents, event : "ctlogin"});
      }

      let clevertapEventsDataUpdateProfile = {};
      // Populate the object with various properties if they are available in the updateProfileCookies
      if(updateProfileCookies?.name) clevertapEventsDataUpdateProfile.userName = updateProfileCookies?.name?.trim();
      if(updateProfileCookies?.mobile) clevertapEventsDataUpdateProfile.userMobile = updateProfileCookies?.mobile;
      if(updateProfileCookies?.education_level?.label) 
      clevertapEventsDataUpdateProfile.studyingIn = updateProfileCookies?.education_level?.label;
      if(updateProfileCookies?.location) 
      clevertapEventsDataUpdateProfile.userLocation = updateProfileCookies?.location?.label;
      if(updateProfileCookies?.education_interest || updateProfileCookies?.certificate_interest) 
      clevertapEventsDataUpdateProfile.eduInterest = (updateProfileCookies?.education_interest?.label || updateProfileCookies?.education_interest?.value) || updateProfileCookies?.certificate_interest?.label;
      if(updateProfileCookies?.target_year) 
      clevertapEventsDataUpdateProfile.admissionTarget = updateProfileCookies?.target_year?.label;
      if(updateProfileCookies?.passing_year) 
      clevertapEventsDataUpdateProfile.passingYear = updateProfileCookies?.passing_year?.label;
      
      // Push the data to the dataLayer for clevertap events
      window.dataLayer.push({...clevertapEventsDataUpdateProfile, event : "ctupdateprofile"});
   }
   
   // Function to handle navigation based on an object value
    const handleNavigate = (obj) => {
        if (obj === "yes") {

        // remove unnecessary cookies when user clicks on "no Iwant to exit" in popup which comes on clicking on cross button in form.
          cookies.remove("registrationState", {
            path: "/",
            domain: destinationDomain,
          });
          cookies.remove("loginState", {
            path: "/",
            domain: destinationDomain,
          });
          cookies.remove("user-agent-key", {
            path: "/",
            domain: destinationDomain,
          });
          setReloadFlagOnExit(false);
        }
      }

    return (
        <div className="careers_register_main">
            {domain &&
                <>
                   {(props.updateProfileData?.proceed && props.updateProfileData?.ask_update_profile == false) ? 
                   <div className="text-center">
                    {/* Display loading indicator when update profile data is being processed */}
                   <Loading colour = {"FFA500"} size={100} />
                   </div> : 
                   <> 
                  <DataLayerEvents contentType={"Login/Signup"} pageTypes={"update_profile"} verticalName={domain?.domain}/> 
                  
                    {/* Left side section of the registration page */}
                   <div className="careers_register_leftside">
                        <CareersRegisterLeft />
                    </div>
                  {/* Right side section of the registration page */}
                  <div tabIndex="0" id="manage_dropdown_leftshift" className="careers_register_rightside">
                        {/* Render the update profile component */}
                        <CareersRegisterUpdateProfile domain={domain} 
                        reloadFlagOnExit={reloadFlagOnExit} 
                        reloadFlagDestination={reloadFlagDestination}
                        />
                    </div></>}
                   
                   {/* Common modal for handling user confirmation on exit */}
                    <CommonModal
                    isOpen={open}
                    showCloseIcon={false}
                    closeOnOverlayClick={false}
                    closeOnEsc={false}
                    closeModal={() => {
                    setOpen(false); // Close the modal
                    }}
                    classNames={{ root: "continue_modal" }}
                >
                    <div className="careers_register_modal">
                    <div className="careers_register_modal_header">
                        <img src={logo} alt="logo" />
                    </div>
                    <div className="careers_register_modal_body careers_register_modal_body_back_button">
                        <p>Wait! Your learning journey is just one step away.</p>
                        <p> By exiting , you may not be able to access resources.</p>
                        <p>Do you want to continue?</p>
                        <div className="careers_register_modal_buttons">
                        {/* Button to exit and handle the navigate logic */}
                        <button onClick={() => handleNavigate("yes")} >{deviceType == "mobile" ? "No, exit" : "No, I want to Exit"}</button>

                        {/* Button to close the modal and continue */}
                        <button className="careers_register_modal_button_active" onClick={() => setOpen(false)}>
                            {deviceType == "mobile" ? "Yes, Continue" : "Yes,  I want to Continue"}
                        </button>
                        </div>
                    </div>
                    </div>
                </CommonModal>
                </>}
        </div>
    );
};
const mapStateToProps = (state) => {
  return {
      userIps: state.usersCommonData?.userIp,
      userIpError: state.usersCommonData?.userIpError,
      loginDatas: state.usersCommonData?.loginData,
      postSignupData: state.userSignUpFields?.signupData,
      geolocationData: state.usersCommonData?.geoLocation,
      updateProfileData: state.usersCommonData?.updateProfile,
      userError: state.userData?.user_error,
      user: state.userData?.user?.data,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
      dispatch,
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegisterUpdateProfile);